/**
 * Context for the page path.
 */
import { createContext } from 'react';

const PagePathContext = createContext<string | null>(null);

export default PagePathContext;
